var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard-greeting"}},[_c('h2',[_vm._v("Hello "+_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }